import axios from 'axios';
import { API_KEY, API_URL } from '../config/env';
import { decrypt } from '../utils/crypto';
import i18n from '../i18n/i18n';

/**
 * İletişim formu — `POST api/Contact/Send` (herkese açık; yalnızca x-root, oturum açıksa Bearer ile kullanıcıya bağlanır).
 * Toast göstermez ve oturum yönlendirmesi yapmaz: sonucu form kendisi gösterir (kullanıcının yazdığı metin korunur).
 * Dönüş: { success, statusCode, message, errors } — ağ hatasında statusCode 0.
 */
const LANG = { tr: '1', en: '2' };

const currentLanguage = () => {
  const code = String(i18n.language || '').slice(0, 2).toLowerCase();
  return LANG[code] ? code : 'tr';
};

const headers = () => {
  const lng = currentLanguage();
  const h = {
    'Content-Type': 'application/json',
    accept: 'application/json',
    'x-root': API_KEY,
    ChannelId: '1',
    lang: LANG[lng],
    language: lng,
  };
  try {
    const enc = localStorage.getItem('authToken');
    const token = enc ? decrypt(enc) : null;
    if (token && typeof token === 'string') h.Authorization = `Bearer ${token}`;
  } catch {
    /* geçersiz/okunamayan token: oturumsuz gönderilir */
  }
  return h;
};

export const sendContactMessage = async (payload) => {
  try {
    const res = await axios.post(`${API_URL}Contact/Send`, payload, { headers: headers(), validateStatus: () => true, timeout: 20000 });
    const body = res.data && typeof res.data === 'object' ? res.data : {};
    const code = res.status !== 200 ? res.status : Number(body.statusCode) || 200;
    return {
      success: code === 200,
      statusCode: code,
      message: typeof body.message === 'string' ? body.message : null,
      errors: Array.isArray(body.errors) ? body.errors : [],
    };
  } catch {
    return { success: false, statusCode: 0, message: null, errors: [] };
  }
};
